export default __webpack_public_path__ + "static/media/arrowBack.f414e799.svg";